// HAPPYCAP_FOOTER_LIGHT_V1
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer({ loginStyle = false }) {
  const { t } = useTranslation();

  return (
    <footer
      className={
        "bg-[#EAF3FB] border-t border-[#C9DBEA] py-5 text-sm text-[#45647C]"
      }
      role="contentinfo"
      aria-label="Pied de page"
    >
      <div className="max-w-6xl mx-auto px-5 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-center">
        <Link
          to="/politica/terms"
          className="inline-flex min-h-[36px] items-center rounded-md px-1 transition-colors duration-200 hover:text-[#247BA8] hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#247BA8]"
          aria-label={t("footer.terms")}
        >
          {t("footer.terms")}
        </Link>
        <Link
          to="/politica/privacy"
          className="inline-flex min-h-[36px] items-center rounded-md px-1 transition-colors duration-200 hover:text-[#247BA8] hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#247BA8]"
          aria-label={t("footer.privacy")}
        >
          {t("footer.privacy")}
        </Link>
        <Link
          to="/politica/cookies"
          className="inline-flex min-h-[36px] items-center rounded-md px-1 transition-colors duration-200 hover:text-[#247BA8] hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#247BA8]"
          aria-label={t("footer.cookies")}
        >
          {t("footer.cookies")}
        </Link>
        <Link
          to="/politica/legal"
          className="inline-flex min-h-[36px] items-center rounded-md px-1 transition-colors duration-200 hover:text-[#247BA8] hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#247BA8]"
          aria-label={t("footer.legal")}
        >
          {t("footer.legal")}
        </Link>
      </div>
      <p className={
        "mt-2 text-center text-xs text-[#71869A]"
      }>
        © {new Date().getFullYear()} Happycap.eu
      </p>
    </footer>
  );
}
